import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/chat-box-header.png'
import _imports_1 from '../images/send.png'


const _withScopeId = n => (_pushScopeId("data-v-d9d053a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "fixed-box",
  ref: "fixedBox"
}
const _hoisted_2 = { class: "items" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQRNYyAH38zAAAG5Lfilrk548.png",
    alt: "otimes Contact Supplier"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQRNYyAYSFcAAALeOZb3a8447.png",
    alt: "otimes Whatsapp"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQRNZOAakhDAAAEg2EY_yI204.png",
    alt: "otimes Wechat"
  })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "count"
}
const _hoisted_7 = { class: "number" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/99/cjez0GQROIqAdiKXAAAeMavOwN8167.png",
  alt: "shop"
}, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "chat-con"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header",
  src: _imports_0,
  alt: "header"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "send",
  src: _imports_1,
  alt: "send"
}, null, -1))
const _hoisted_12 = {
  key: 2,
  ref: "shopRef",
  class: "shop-con"
}
const _hoisted_13 = { class: "header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Your Inquiry Basket", -1))
const _hoisted_15 = { class: "list" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "right" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  style: {"margin-top":"50px","width":"100%","text-align":"center"}
}
const _hoisted_22 = {
  key: 3,
  class: "code-con"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.otimes.com/group1/M00/3A/3A/123456789123456789123456789wechat.png",
  alt: "otimes log"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Scan me to add wechat", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      false
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "item",
            style: _normalizeStyle({ backgroundColor: _ctx.activeTag === 1 ? 'rgba(0, 120, 221, 0.08)' : '' }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle(1)))
          }, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "name",
              style: _normalizeStyle({ color: _ctx.activeTag === 1 ? '#0078DD' : '' })
            }, "Contact Supplier", 4)
          ], 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "item",
        style: _normalizeStyle({ backgroundColor: _ctx.activeTag === 2 ? 'rgba(0, 120, 221, 0.08)' : '' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle(2), _ctx.chatTag = !_ctx.chatTag))
      }, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "name",
          style: _normalizeStyle({ color: _ctx.activeTag === 2 ? '#0078DD' : '' })
        }, "Whatsapp", 4)
      ], 4),
      _createElementVNode("div", {
        class: "item",
        style: _normalizeStyle({ backgroundColor: _ctx.activeTag === 3 ? 'rgba(0, 120, 221, 0.08)' : '' }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle(3), _ctx.showCode = !_ctx.showCode))
      }, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "name",
          style: _normalizeStyle({ color: _ctx.activeTag === 3 ? '#0078DD' : '' })
        }, "Wechat", 4)
      ], 4)
    ]),
    (_ctx.showShopBt)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "shop",
          ref: "shopRefBt",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickShop && _ctx.clickShop(...args)))
        }, [
          (_ctx.shopList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.shopList.length), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_8
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.chatTag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.chatTag = false))
          }, [
            _createVNode(_component_el_icon, {
              color: "#fff",
              size: 16
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 1
            })
          ]),
          _hoisted_10,
          _createVNode(_component_el_input, {
            class: "content",
            type: "textarea",
            rows: 13,
            resize: "none",
            placeholder: "Please enter here...",
            modelValue: _ctx.text,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.text) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_link, {
            underline: false,
            target: "_blank",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getUrl(), _ctx.chatTag = !_ctx.chatTag, _ctx.text = ''))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showShop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showShop = false))
            }, [
              _createVNode(_component_el_icon, { size: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item",
                key: item.id
              }, [
                _createElementVNode("img", {
                  src: _ctx.splitImg(item.allImg),
                  alt: item.title
                }, null, 8, _hoisted_16),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: item.title,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]),
                  _createElementVNode("div", {
                    class: "bt",
                    onClick: ($event: any) => (_ctx.remove(item))
                  }, " Remove ", 8, _hoisted_20)
                ])
              ]))
            }), 128)),
            (!_ctx.shopList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "No items found."))
              : _createCommentVNode("", true)
          ]),
          (_ctx.shopList.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sub",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showTalk && _ctx.showTalk(...args)))
              }, "Product Inquiry"))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.showCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
      : _createCommentVNode("", true)
  ], 512))
}